import { mapping as deviceBaseFilterMapper } from '../../common/device-base/device-base-filter.mapper'

const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  ...deviceBaseFilterMapper,
  name: (lambdaParameter, value) =>
    `${lambdaParameter}.Name.Contains("${value}")`,
  address: (lambdaParameter, value) =>
    `${lambdaParameter}.Address.Contains("${value}")`,
  automatAPIAddress: (lambdaParameter, value) =>
    `${lambdaParameter}.AutomatAPIAddress.Contains("${value}")`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.Name).Contains("${q}")`,
      )
      .join('&&')}`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
